import userType from './auth/userType'

export default {
  items: [
    {
      name: 'Projekty',
      url: '/projects',
      icon: 'icon-bulb',
      userTypes: [userType.admin, userType.user]
    },
    {
      name: 'Formularze',
      url: '/forms',
      icon: 'icon-notebook',
      userTypes: [userType.admin, userType.user]
    },
    {
      name: 'Leady',
      url: '/leads',
      icon: 'icon-basket-loaded',
      userTypes: [userType.admin, userType.user]
    }
  ]
}
